"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trialBalance = trialBalance;
const money_1 = require("../money");
/**
 * ميزان المراجعة يُحسب دائمًا من سطور القيود غير القابلة للتغيير،
 * ولا يُقرأ من رصيد مخزَّن قابل للانحراف.
 */
function trialBalance(lines, accounts) {
    const totals = new Map();
    for (const line of lines) {
        const current = totals.get(line.accountCode) ?? { debit: money_1.Money.zero(), credit: money_1.Money.zero() };
        totals.set(line.accountCode, {
            debit: current.debit.add(line.debit),
            credit: current.credit.add(line.credit),
        });
    }
    const rows = [...totals.entries()]
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([accountCode, sums]) => {
        const account = accounts.get(accountCode);
        const naturallyCredit = account?.normalBalance === 'credit';
        const balance = naturallyCredit
            ? sums.credit.sub(sums.debit).normalize()
            : sums.debit.sub(sums.credit).normalize();
        return {
            accountCode,
            debit: sums.debit.normalize(),
            credit: sums.credit.normalize(),
            balance,
        };
    });
    const totalDebit = money_1.Money.sum(rows.map((row) => row.debit)).normalize();
    const totalCredit = money_1.Money.sum(rows.map((row) => row.credit)).normalize();
    return {
        rows,
        totalDebit,
        totalCredit,
        isBalanced: totalDebit.eq(totalCredit),
    };
}
//# sourceMappingURL=trial-balance.js.map